export const initialState = {
  warning: null,
  isIntroModalOpen: true,
  isBusinessPlanModalOpen: false,
  isConclusionsModalOpen: false,
  isForecastsModalOpen: false,
  isDecisionFormsModalOpen: false,
  isPlanComparisonModalOpen: false,
  businessPlanModalStep: 0,
  conclusionsModalStep: 0,
  decisionFormsModalStep: 0,
  year2TutorialStep: null,
  year3TutorialStep: null,
  planComparisonTutorialCompletedYears: [],
  endOfYearPlanComparisonCompletedYears: [],
  year1DialogueCompleted: false,
  year1CompletedTutorials: {},
  year2CompletedTutorials: {},
  year3CompletedTutorials: {},
  tutorialStateLoaded: false,
  tutorialInteractionCompleted: null,
  /**
   * After plan-comparison close, which Reports sidebar Robotutor to run (if any).
   * null when idle.
   */
  reportsRobotutorVariant: null
}

// eslint-disable-next-line default-param-last
export function tutorReducer(state = initialState, action) {
  switch (action.type) {
    case 'tutor/setWarning':
      return { ...state, warning: action.payload }
    case 'tutor/clearWarning':
      return { ...state, warning: null }
    case 'tutor/setIntroModalOpen':
      return { ...state, isIntroModalOpen: action.payload }
    case 'tutor/setBusinessPlanModalOpen':
      return { ...state, isBusinessPlanModalOpen: action.payload }
    case 'tutor/setBusinessPlanModalStep':
      return { ...state, businessPlanModalStep: action.payload }
    case 'tutor/setConclusionsModalOpen':
      return { ...state, isConclusionsModalOpen: action.payload }
    case 'tutor/setConclusionsModalStep':
      return { ...state, conclusionsModalStep: action.payload }
    case 'tutor/setForecastsModalOpen':
      return { ...state, isForecastsModalOpen: action.payload }
    case 'tutor/setDecisionFormsModalOpen':
      return { ...state, isDecisionFormsModalOpen: action.payload }
    case 'tutor/setDecisionFormsModalStep':
      return { ...state, decisionFormsModalStep: action.payload }
    case 'tutor/setPlanComparisonModalOpen':
      return { ...state, isPlanComparisonModalOpen: action.payload }
    case 'tutor/setPlanComparisonTutorialCompletedYears':
      return { ...state, planComparisonTutorialCompletedYears: action.payload }
    case 'tutor/setEndOfYearPlanComparisonCompletedYears':
      return { ...state, endOfYearPlanComparisonCompletedYears: action.payload }
    case 'tutor/setYear2TutorialStep':
      return { ...state, year2TutorialStep: action.payload }
    case 'tutor/setYear3TutorialStep':
      return { ...state, year3TutorialStep: action.payload }
    case 'tutor/setYear1DialogueCompleted':
      return { ...state, year1DialogueCompleted: action.payload }
    case 'tutor/setYear1TutorialCompleted':
      return {
        ...state,
        year1CompletedTutorials: {
          ...state.year1CompletedTutorials,
          [action.payload]: true
        }
      }
    case 'tutor/setYear2TutorialCompleted':
      return {
        ...state,
        year2CompletedTutorials: {
          ...state.year2CompletedTutorials,
          [action.payload]: true
        }
      }
    case 'tutor/setYear3TutorialCompleted':
      return {
        ...state,
        year3CompletedTutorials: {
          ...state.year3CompletedTutorials,
          [action.payload]: true
        }
      }
    case 'tutor/loadTutorialState':
      return {
        ...state,
        year2TutorialStep: action.payload.year2TutorialStep || null,
        year3TutorialStep: action.payload.year3TutorialStep || null,
        planComparisonTutorialCompletedYears:
          action.payload.planComparisonTutorialCompletedYears || [],
        endOfYearPlanComparisonCompletedYears:
          action.payload.endOfYearPlanComparisonCompletedYears || [],
        year1DialogueCompleted: action.payload.year1DialogueCompleted || false,
        year1CompletedTutorials: action.payload.year1CompletedTutorials || {},
        year2CompletedTutorials: action.payload.year2CompletedTutorials || {},
        year3CompletedTutorials: action.payload.year3CompletedTutorials || {},
        tutorialStateLoaded: true
      }
    case 'tutor/setTutorialInteractionCompleted':
      return { ...state, tutorialInteractionCompleted: action.payload }
    case 'tutor/setReportsRobotutorVariant':
      return { ...state, reportsRobotutorVariant: action.payload }
    default:
      return state
  }
}

export default tutorReducer

export const setWarning = (
  message,
  type = 'action',
  notificationPosition = 'bottom',
  notificationMargin = null,
  interpolation = null
) => ({
  type: 'tutor/setWarning',
  payload: { message, type, notificationPosition, notificationMargin, interpolation }
})

export const clearWarning = () => ({
  type: 'tutor/clearWarning'
})

export const setIntroModalOpen = (isOpen) => ({
  type: 'tutor/setIntroModalOpen',
  payload: isOpen
})

export const setBusinessPlanModalOpen = (isOpen) => ({
  type: 'tutor/setBusinessPlanModalOpen',
  payload: isOpen
})

export const setBusinessPlanModalStep = (step) => ({
  type: 'tutor/setBusinessPlanModalStep',
  payload: step
})

export const setConclusionsModalOpen = (isOpen) => ({
  type: 'tutor/setConclusionsModalOpen',
  payload: isOpen
})

export const setConclusionsModalStep = (step) => ({
  type: 'tutor/setConclusionsModalStep',
  payload: step
})

export const setForecastsModalOpen = (isOpen) => ({
  type: 'tutor/setForecastsModalOpen',
  payload: isOpen
})

export const setDecisionFormsModalOpen = (isOpen) => ({
  type: 'tutor/setDecisionFormsModalOpen',
  payload: isOpen
})

export const setDecisionFormsModalStep = (step) => ({
  type: 'tutor/setDecisionFormsModalStep',
  payload: step
})

export const setPlanComparisonModalOpen = (isOpen) => ({
  type: 'tutor/setPlanComparisonModalOpen',
  payload: isOpen
})

export const setTutorialInteractionCompleted = (actionState) => ({
  type: 'tutor/setTutorialInteractionCompleted',
  payload: actionState
})

export const REPORTS_ROBOTUTOR_VARIANT_COST_ACCOUNTING_YEAR4 = 'cost-accounting-year4'
export const REPORTS_ROBOTUTOR_VARIANT_CONTRIBUTION_MARGIN_YEAR5 = 'contribution-margin-year5'
export const REPORTS_ROBOTUTOR_VARIANT_KEY_FIGURES_YEAR5 = 'key-figures-year5'
export const REPORTS_ROBOTUTOR_VARIANT_KEY_FIGURES_YEAR6 = 'key-figures-year6'

export const setReportsRobotutorVariant = (value) => ({
  type: 'tutor/setReportsRobotutorVariant',
  payload: value
})

// Helper to get game-specific localStorage key
const getGameStorageKey = (gameId, key) => `game_${gameId}_${key}`

// Load tutorial state from localStorage for a specific game
export const loadTutorialState = () => (dispatch, getState) => {
  const state = getState()
  const gameId = state.user?.game?.data?.id

  let year2TutorialStep = null
  let year3TutorialStep = null
  let year1DialogueCompleted = false
  let year1CompletedTutorials = {}
  let year2CompletedTutorials = {}
  let year3CompletedTutorials = {}
  let planComparisonTutorialCompletedYears = []
  let endOfYearPlanComparisonCompletedYears = []

  if (gameId) {
    try {
      const year2Step = localStorage.getItem(getGameStorageKey(gameId, 'year2TutorialStep'))
      const year3Step = localStorage.getItem(getGameStorageKey(gameId, 'year3TutorialStep'))
      const planComparisonYearsStr = localStorage.getItem(
        getGameStorageKey(gameId, 'planComparisonTutorialCompletedYears')
      )
      const endOfYearPlanComparisonYearsStr = localStorage.getItem(
        getGameStorageKey(gameId, 'endOfYearPlanComparisonCompletedYears')
      )
      const year1Completed = localStorage.getItem(
        getGameStorageKey(gameId, 'year1DialogueCompleted')
      )
      const year1CompletedTutorialsStr = localStorage.getItem(
        getGameStorageKey(gameId, 'year1CompletedTutorials')
      )
      const year2CompletedTutorialsStr = localStorage.getItem(
        getGameStorageKey(gameId, 'year2CompletedTutorials')
      )
      const year3CompletedTutorialsStr = localStorage.getItem(
        getGameStorageKey(gameId, 'year3CompletedTutorials')
      )

      year2TutorialStep = year2Step || null
      year3TutorialStep = year3Step || null
      year1DialogueCompleted = year1Completed === 'true'

      if (planComparisonYearsStr) {
        try {
          planComparisonTutorialCompletedYears = JSON.parse(planComparisonYearsStr)
        } catch {
          planComparisonTutorialCompletedYears = []
        }
      }

      if (endOfYearPlanComparisonYearsStr) {
        try {
          endOfYearPlanComparisonCompletedYears = JSON.parse(endOfYearPlanComparisonYearsStr)
        } catch {
          endOfYearPlanComparisonCompletedYears = []
        }
      }

      if (year3TutorialStep === 'completed' && !planComparisonTutorialCompletedYears.includes(3)) {
        planComparisonTutorialCompletedYears = [...planComparisonTutorialCompletedYears, 3]
        localStorage.setItem(
          getGameStorageKey(gameId, 'planComparisonTutorialCompletedYears'),
          JSON.stringify(planComparisonTutorialCompletedYears)
        )
      }

      if (year1CompletedTutorialsStr) {
        try {
          year1CompletedTutorials = JSON.parse(year1CompletedTutorialsStr)
        } catch {
          year1CompletedTutorials = {}
        }
      }

      if (year2CompletedTutorialsStr) {
        try {
          year2CompletedTutorials = JSON.parse(year2CompletedTutorialsStr)
        } catch {
          year2CompletedTutorials = {}
        }
      }

      if (year3CompletedTutorialsStr) {
        try {
          year3CompletedTutorials = JSON.parse(year3CompletedTutorialsStr)
        } catch {
          year3CompletedTutorials = {}
        }
      }
    } catch (error) {
      // Ignore localStorage errors, use defaults
    }
  }

  dispatch({
    type: 'tutor/loadTutorialState',
    payload: {
      year2TutorialStep,
      year3TutorialStep,
      planComparisonTutorialCompletedYears,
      endOfYearPlanComparisonCompletedYears,
      year1DialogueCompleted,
      year1CompletedTutorials,
      year2CompletedTutorials,
      year3CompletedTutorials
    }
  })
}

export const recordPlanComparisonTutorialCompleted = (gameYear) => (dispatch, getState) => {
  const state = getState()
  const gameId = state.user?.game?.data?.id
  const current = state.tutor.planComparisonTutorialCompletedYears || []
  if (current.includes(gameYear)) {
    return
  }

  const next = [...current, gameYear].sort((a, b) => a - b)

  dispatch({
    type: 'tutor/setPlanComparisonTutorialCompletedYears',
    payload: next
  })

  if (gameId) {
    try {
      localStorage.setItem(
        getGameStorageKey(gameId, 'planComparisonTutorialCompletedYears'),
        JSON.stringify(next)
      )
    } catch (error) {
      // Ignore localStorage errors
    }
  }
}

export const recordEndOfYearPlanComparisonCompleted = (reviewYear) => (dispatch, getState) => {
  const state = getState()
  const gameId = state.user?.game?.data?.id
  const current = state.tutor.endOfYearPlanComparisonCompletedYears || []
  if (current.includes(reviewYear)) {
    return
  }

  const next = [...current, reviewYear].sort((a, b) => a - b)

  dispatch({
    type: 'tutor/setEndOfYearPlanComparisonCompletedYears',
    payload: next
  })

  if (gameId) {
    try {
      localStorage.setItem(
        getGameStorageKey(gameId, 'endOfYearPlanComparisonCompletedYears'),
        JSON.stringify(next)
      )
    } catch (error) {
      // Ignore localStorage errors
    }
  }
}

// Set Year 2 tutorial step with game-specific persistence
export const setYear3TutorialStep = (step) => (dispatch, getState) => {
  const state = getState()
  const gameId = state.user?.game?.data?.id

  dispatch({
    type: 'tutor/setYear3TutorialStep',
    payload: step
  })

  if (gameId) {
    try {
      if (step === null) {
        localStorage.removeItem(getGameStorageKey(gameId, 'year3TutorialStep'))
      } else {
        localStorage.setItem(getGameStorageKey(gameId, 'year3TutorialStep'), step)
      }
    } catch (error) {
      // Ignore localStorage errors
    }
  }
}

export const setYear2TutorialStep = (step) => (dispatch, getState) => {
  const state = getState()
  const gameId = state.user?.game?.data?.id

  dispatch({
    type: 'tutor/setYear2TutorialStep',
    payload: step
  })

  if (gameId) {
    try {
      if (step === null) {
        localStorage.removeItem(getGameStorageKey(gameId, 'year2TutorialStep'))
      } else {
        localStorage.setItem(getGameStorageKey(gameId, 'year2TutorialStep'), step)
      }
    } catch (error) {
      // Ignore localStorage errors
    }
  }
}

// Set Year 1 dialogue completed with game-specific persistence
export const setYear1DialogueCompleted = (completed) => (dispatch, getState) => {
  const state = getState()
  const gameId = state.user?.game?.data?.id

  dispatch({
    type: 'tutor/setYear1DialogueCompleted',
    payload: completed
  })

  if (gameId) {
    try {
      localStorage.setItem(
        getGameStorageKey(gameId, 'year1DialogueCompleted'),
        completed.toString()
      )
    } catch (error) {
      // Ignore localStorage errors
    }
  }
}

// Mark a Year 1 RoboTutor tutorial as completed with game-specific persistence
export const setYear1TutorialCompleted = (messageKey) => (dispatch, getState) => {
  const state = getState()
  const gameId = state.user?.game?.data?.id

  dispatch({
    type: 'tutor/setYear1TutorialCompleted',
    payload: messageKey
  })

  if (gameId) {
    try {
      const currentCompletedStr = localStorage.getItem(
        getGameStorageKey(gameId, 'year1CompletedTutorials')
      )
      let currentCompleted = {}
      if (currentCompletedStr) {
        try {
          currentCompleted = JSON.parse(currentCompletedStr)
        } catch {
          currentCompleted = {}
        }
      }

      currentCompleted[messageKey] = true

      localStorage.setItem(
        getGameStorageKey(gameId, 'year1CompletedTutorials'),
        JSON.stringify(currentCompleted)
      )
    } catch (error) {
      // Ignore localStorage errors
    }
  }
}

// Mark a Year 2 RoboTutor tutorial as completed with game-specific persistence
export const setYear2TutorialCompleted = (messageKey) => (dispatch, getState) => {
  const state = getState()
  const gameId = state.user?.game?.data?.id

  dispatch({
    type: 'tutor/setYear2TutorialCompleted',
    payload: messageKey
  })

  if (gameId) {
    try {
      const currentCompletedStr = localStorage.getItem(
        getGameStorageKey(gameId, 'year2CompletedTutorials')
      )
      let currentCompleted = {}
      if (currentCompletedStr) {
        try {
          currentCompleted = JSON.parse(currentCompletedStr)
        } catch {
          currentCompleted = {}
        }
      }

      currentCompleted[messageKey] = true

      localStorage.setItem(
        getGameStorageKey(gameId, 'year2CompletedTutorials'),
        JSON.stringify(currentCompleted)
      )
    } catch (error) {
      // Ignore localStorage errors
    }
  }
}

export const setYear3TutorialCompleted = (messageKey) => (dispatch, getState) => {
  const state = getState()
  const gameId = state.user?.game?.data?.id

  dispatch({
    type: 'tutor/setYear3TutorialCompleted',
    payload: messageKey
  })

  if (gameId) {
    try {
      const currentCompletedStr = localStorage.getItem(
        getGameStorageKey(gameId, 'year3CompletedTutorials')
      )
      let currentCompleted = {}
      if (currentCompletedStr) {
        try {
          currentCompleted = JSON.parse(currentCompletedStr)
        } catch {
          currentCompleted = {}
        }
      }

      currentCompleted[messageKey] = true

      localStorage.setItem(
        getGameStorageKey(gameId, 'year3CompletedTutorials'),
        JSON.stringify(currentCompleted)
      )
    } catch (error) {
      // Ignore localStorage errors
    }
  }
}
